import { render, staticRenderFns } from "./CustomizeMetalBA.vue?vue&type=template&id=95bc093c&scoped=true"
import script from "./CustomizeMetalBA.vue?vue&type=script&lang=js"
export * from "./CustomizeMetalBA.vue?vue&type=script&lang=js"
import style0 from "./CustomizeMetalBA.vue?vue&type=style&index=0&id=95bc093c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95bc093c",
  null
  
)

export default component.exports